import { render } from "./Timeline.vue?vue&type=template&id=28bfe7f3"
import script from "./Timeline.vue?vue&type=script&lang=js"
export * from "./Timeline.vue?vue&type=script&lang=js"
script.render = render

export default script